import React from "react"

const ProjectSectionTitle = ({children}) => {
  return (
    <div className={`project-section-title`}>{children}</div>
  )
}

export default ProjectSectionTitle